'use strict';
import angular from 'angular';
import './tag.values.details.services';
import './tag.values.details.components';

angular.module('tag.values.details', [
    'tag.values.details.services',
    'tag.values.details.components'
])